
import CustomForm from './CustomForm.vue';
import MyModal from '~/components/modals/MyModal.vue';

export default {
    name: 'FormPopup',
    components: {
        CustomForm,
        MyModal,
    },
    props: {
        // Пропсы для CustomForm
        form_title: { type: String, default: '' },
        description: { type: String, default: '' },
        backgroundImage: { type: String, default: '' },
        submitButtonText: { type: String, default: 'Отправить' },
        fields: { type: Array, required: true, default: () => [] },
    },
    data() {
        return {
            isPopupVisible: false,
        };
    },
    methods: {
        openPopup() {
            this.isPopupVisible = true;
        },
        closePopup() {
            this.isPopupVisible = false;
        },
    },
};
